export const GET_VEHICLE_RECOMMENDATION = "GET_VEHICLE_RECOMMENDATION";
export const GET_VEHICLES = "GET_VEHICLES";